import { render, staticRenderFns } from "./DepartureTabsExtras.vue?vue&type=template&id=4cc9fd36&scoped=true&"
import script from "./DepartureTabsExtras.vue?vue&type=script&lang=js&"
export * from "./DepartureTabsExtras.vue?vue&type=script&lang=js&"
import style0 from "./DepartureTabsExtras.vue?vue&type=style&index=0&id=4cc9fd36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc9fd36",
  null
  
)

export default component.exports